import React from "react";
import { BLOCK } from "../agent/agentContract";
import TextBlock from "./blocks/TextBlock";
import QuickReplyBlock from "./blocks/QuickReplyBlock";
import CtaChipsBlock from "./blocks/CtaChipsBlock";
import TableRefBlock from "./blocks/TableRefBlock";
import ProgressBlock from "./blocks/ProgressBlock";
import ConfirmationBlock from "./blocks/ConfirmationBlock";
import ConnectIntegrationBlock from "./blocks/ConnectIntegrationBlock";
import SummaryCardBlock from "./blocks/SummaryCardBlock";
import ErrorCtaBlock from "./blocks/ErrorCtaBlock";
import LivePreviewBlock from "./blocks/LivePreviewBlock";
import QuestionFormBlock from "./blocks/QuestionFormBlock";
import EntityCardsBlock from "./blocks/EntityCardsBlock";
import DraftReviewBlock from "./blocks/DraftReviewBlock";

const BLOCK_COMPONENTS = {
  [BLOCK.TEXT]: TextBlock,
  [BLOCK.QUICK_REPLIES]: QuickReplyBlock,
  [BLOCK.CTA_CHIPS]: CtaChipsBlock,
  [BLOCK.TABLE_REF]: TableRefBlock,
  [BLOCK.PROGRESS]: ProgressBlock,
  [BLOCK.CONFIRMATION]: ConfirmationBlock,
  [BLOCK.CONNECT_INTEGRATION]: ConnectIntegrationBlock,
  [BLOCK.SUMMARY_CARD]: SummaryCardBlock,
  [BLOCK.ERROR_CTA]: ErrorCtaBlock,
  [BLOCK.LIVE_PREVIEW]: LivePreviewBlock,
  [BLOCK.QUESTION_FORM]: QuestionFormBlock,
  [BLOCK.ENTITY_CARDS]: EntityCardsBlock,
  [BLOCK.DRAFT_REVIEW]: DraftReviewBlock
};

// Unknown block types from a newer agent render as nothing instead of
// crashing the thread — forward compatibility for the contract.
// `hidden` retracts an already-started block (e.g. a tool call that failed on
// a filter-vocabulary technicality and is being silently retried) — the user
// should never see internal retries surface as errors.
const BlockRenderer = ({ block, isStreaming }) => {
  const Component = BLOCK_COMPONENTS[block.type];
  if (!Component || block.hidden) return null;
  return <Component block={block} isStreaming={isStreaming} />;
};

export default BlockRenderer;
